import React, { useMemo } from 'react'
import { personalisationFaqs, verificationFaqs } from '../../common/constants'
import OnBoardingFaqAccordion from './onBoardingFaqAccordion'
import { useSelector } from 'react-redux';


const OnBoardingFaq = () => {
    const type = useSelector((store) => store?.onBoarding?.type) || "";

    const getFaqs = useMemo(() => {
        if(type === "course") {
            return personalisationFaqs;
        } else {
            return verificationFaqs;
        }
    }, [type]) || [];

    
   return (
        <div className='flex flex-col w-full'>
            {getFaqs?.map(({ question, answer }, index) => (
                <OnBoardingFaqAccordion title={question} key={index} index={index} length={getFaqs?.length} content={answer}/>
            ))}
        </div>
    )
}

export default OnBoardingFaq
